import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { createMoment } from '../api/moments';

const today = () => new Date().toISOString().slice(0, 10);

function NewMoment() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [description, setDescription] = useState('');
  const [date, setDate] = useState(today());
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('auth_token');
    try {
      await createMoment(id, description, date, token);
      navigate('/moments');
    } catch {
      setError('Failed to save moment. Please try again.');
    }
  };

  return (
    <div className="new-moment">
      <Link to={`/events/${id}`} className="back-link">← Back to Event</Link>
      <h1>Add a Moment</h1>
      <form onSubmit={handleSubmit} className="moment-form">
        <label className="moment-form__label" htmlFor="moment-date">
          Date you attended
        </label>
        <input
          id="moment-date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
          className="moment-form__date"
        />
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Describe your moment..."
          required
        />
        {error && <p className="error">{error}</p>}
        <button type="submit" className="btn btn-primary">Save Moment</button>
      </form>
    </div>
  );
}

export default NewMoment;
